/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'
import axios from 'axios'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
import 'bootstrap';
import moment from 'moment'
import 'moment/locale/fr'
import numeral from 'numeral'
import 'vue-bootstrap-datetimepicker'

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// These are globals we need everywhere
// Also take care of changing the localization globally too
window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _;
window.moment = moment;
window.numeral = numeral;
window.trans = (string, args) => {
  let value = _.get(window.i18n, string)
  value = value ? value : string
  _.eachRight(args, (paramVal, paramKey) => {
    value = value.replaceAll(`:${paramKey}`, paramVal)
  })
  return value
}
if (window.lang == 'fr') {
  moment.locale('fr')
  numeral.register('locale', 'fr', {
    delimiters: {
      thousands: ' ',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal : function (number) {
      return number === 1 ? 'er' : 'ème';
    },
    currency: {
      symbol: '$'
    }
  });
  numeral.locale('fr');
} else {
  moment.locale('en')
}

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle'
    }
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
